import Api from '@/services/API';

export default class Rest extends Api {
  static resource = '';

  id = 'id';

  constructor(resource: string, options: Record<string, unknown> = {}, http = null) {
    super(Rest.normalize(Rest.base, resource), options, http);
  }

  static build() {
    return new this(this.resource);
  }

  create(record: Record<string, unknown>) {
    return this.post('', record);
  }

  read(record: string | Record<string, unknown>) {
    return this.get(`/${this.getId(record)}`);
  }

  postID(record: Record<string, unknown>) {
    return this.post(`/${this.getId(record)}`, record);
  }

  postUnicID(record: Record<string, unknown>) {
    return this.post(`/${this.getId(record)}`, undefined);
  }

  postIDArray(record: Record<string, unknown> & { array: unknown }) {
    return this.post(`/${this.getId(record)}`, record.array);
  }

  postID2(record: { id: string | number; data: unknown }) {
    return this.post(`/${this.getId(record.id)}`, record.data);
  }

  update(record: Record<string, unknown>) {
    return this.put(`/${this.getId(record)}`, record);
  }

  updateId(record: string | Record<string, unknown>) {
    return this.put(`/${this.getId(record)}`);
  }

  destroy(record: string | Record<string, unknown>) {
    return this.delete(`/${this.getId(record)}`);
  }

  search(parameters: Record<string, unknown> | string = {}) {
    if (typeof parameters === 'string') {
      return this.get(`?${parameters}`);
    }
    if (Object.keys(parameters).length) {
      return this.get(`?${parameters}`);
    }
    return this.get('');
  }

  search2(parameters: string = '') {
    return this.get(`?${parameters}`);
  }

  getId(record: string | number | Record<string, unknown>): string {
    if (typeof record === 'object' && record !== null) {
      const value = (record as Record<string, unknown>)[this.id];
      return String(value ?? '');
    }
    return String(record);
  }
}
